import { useEffect } from 'react';

/**
 * Composant pour injecter du CSS critique inline
 * Améliore FCP et élimine le render-blocking CSS
 */
export const CriticalCSS = () => {
  useEffect(() => {
    // CSS critique pour éviter FOUC et améliorer FCP
    const criticalStyles = `
      /* Prévenir CLS - Réserver espace pour images */
      img:not([width]):not([height]) {
        aspect-ratio: attr(width) / attr(height);
      }
      
      /* Optimisation polices - Éviter FOIT/FOUT */
      @font-face {
        font-family: 'Orbitron';
        font-display: swap;
        font-weight: 400 900;
        src: url('https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6BoWgz.woff2') format('woff2');
      }
      
      /* Skeleton loading placeholders pour éviter CLS */
      .loading-placeholder {
        background: linear-gradient(90deg, #1e293b 0%, #334155 50%, #1e293b 100%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
      }
      
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      
      /* Éviter layout shift pour le header */
      header {
        min-height: 80px;
      }
      
      /* Base layout pour éviter shifts */
      #root {
        min-height: 100vh;
      }
    `;
    
    // Injecter le CSS critique
    const styleElement = document.createElement('style');
    styleElement.id = 'critical-css';
    styleElement.textContent = criticalStyles;
    document.head.insertBefore(styleElement, document.head.firstChild);
    
    return () => {
      const existingStyle = document.getElementById('critical-css');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);
  
  return null;
};
